module.exports = __webpack_public_path__ + "static/media/HPNM05.77bd647e.jpg";